import Link from "next/link"

type PaperLink = {
	label: string
	href: string
	default?: boolean
}

type Venue = {
	name: string
	href: string
	color?: string
}

interface PaperCardProps {
	title: string
	authors: string | string[]
	venue?: Venue
	links: PaperLink[]
	accepted: boolean
}

const PaperCard = (props: PaperCardProps) => {
	const { title, authors, venue, links, accepted } = props

	// Find the default link
	const defaultLink = (links.find((link) => link.default) ?? venue)?.href

	const authorList = Array.isArray(authors) ? authors : authors.split(",")

	return (
		<div
			onClick={(e) => {
				// If the click originated from a link or inside a link, do nothing
				const isLink = (node: EventTarget | null): boolean => {
					if (!node || !(node instanceof Element)) return false
					if (node.tagName === "A") return true
					if (node === e.currentTarget) return false
					return isLink(node.parentElement)
				}
				if (isLink(e.target)) return
				if (defaultLink) window.open(defaultLink, "_blank")
			}}
			className="group flex w-full cursor-pointer flex-col gap-y-2 rounded-md border bg-white shadow-xs transition-all hover:-translate-y-1 hover:border-gray-300 hover:bg-gray-50 dark:border-gray-700 dark:bg-gray-800 dark:hover:border-gray-600">
			<div className="text-normal flex w-full items-center border-b border-gray-200 px-4.5 py-2.5 font-serif font-medium tracking-wide text-gray-700 dark:border-gray-700 dark:text-white dark:group-hover:border-gray-600">
				<p>{title}</p>
			</div>
			<div className="flex flex-col gap-y-2.5 px-4.5 pt-1 pb-3.5">
				<div className="text-sm tracking-wide text-gray-600 dark:text-gray-300">
					{
						// Make my name (Lipeng He) bold, also split authors by comma
						authorList.map((author, idx) => {
							const isMyName = author.includes("Lipeng He")
							return (
								<span key={author} className={isMyName ? "font-semibold" : ""}>
									{author}
									{idx === authorList.length - 1 ? "" : ","}
								</span>
							)
						})
					}
				</div>
				<div className="flex flex-col items-start gap-x-2.5 gap-y-2 text-xs text-gray-500 lg:-ml-1 lg:flex-row lg:items-center">
					<div
						className={`rounded-full border bg-gray-100 px-2.5 py-0.5 font-medium dark:border-gray-600 dark:bg-gray-700 dark:text-gray-400 ${venue?.color || ""}`}>
						{!accepted ? (
							"Under Submission"
						) : (
							<Link href={venue.href} target="_blank" rel="noopener noreferrer">
								{venue.name}
							</Link>
						)}
					</div>
					<div className="flex items-center justify-between gap-x-2.5 overflow-x-auto text-sm whitespace-nowrap text-gray-500 dark:text-gray-300">
						{links.map((link) => (
							<Link
								key={link.href}
								href={link.href}
								target="_blank"
								rel="noopener noreferrer"
								className="underline underline-offset-4 transition-colors hover:text-blue-500">
								<span>{link.label} →</span>
							</Link>
						))}
					</div>
				</div>
			</div>
		</div>
	)
}

export default PaperCard
